export const RegexOptions = {
  ONLYNUMBERS: /[^0-9]/g,
  ONLYNUMBERSDOTANDCOMMA: /^[0-9.,]/g,
  ONLYNUMBERSANDLETTERS: /^[0-9a-zA-Z]/g,
  ONLYLETTERS: /^[a-zA-Z]/g,
};
